import { type ReactNode, useRef } from "react";
import { Link, useLocation } from "react-router";
import { useFocusReturn } from "./focusReturn";

/**
 * A text link that opens the gallery window of `gid` from a row (download lists, tables).
 * It is the one way such a link is made, so every one of them takes focus back when the window closes
 * and its screen is drawn again (`useFocusReturn`). Cards do the same in `GalleryCard`.
 * The row that holds it carries `data-gid`.
 */
export function GalleryLink({ gid, children }: { gid: number; children: ReactNode }) {
  const location = useLocation();
  const link = useRef<HTMLAnchorElement>(null);
  useFocusReturn(gid, link);
  return (
    <Link ref={link} to={`/g/${gid}`} state={{ inApp: true, background: location }}>
      {children}
    </Link>
  );
}
